import { render, staticRenderFns } from "./xiguanjie-yatongdian-right.vue?vue&type=template&id=1764a80c&scoped=true&"
import script from "./xiguanjie-yatongdian-right.vue?vue&type=script&lang=ts&"
export * from "./xiguanjie-yatongdian-right.vue?vue&type=script&lang=ts&"
import style0 from "./xiguanjie-yatongdian-right.vue?vue&type=style&index=0&id=1764a80c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1764a80c",
  null
  
)

export default component.exports